import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-installation-miscellaneous',
  templateUrl: './installation-miscellaneous.component.html',
  styleUrls: ['./installation-miscellaneous.component.scss']
})
export class InstallationMiscellaneousComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
